import { render, staticRenderFns } from "./XContextMenuItem.vue?vue&type=template&id=ea32a0cc&scoped=true&"
import script from "./XContextMenuItem.vue?vue&type=script&lang=js&"
export * from "./XContextMenuItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea32a0cc",
  null
  
)

export default component.exports